import { apiRequest } from "../../index";

export const getAllBookings = async ({page , limit , status , search}) => {
  return apiRequest(`/api/owner/hotel-management/bookings/listing?page=${page}&limit=${limit}&status=${status}&search=${search}`, "GET");
};

export const getBookingDetail = async (bookingId) => {
  return apiRequest(`/api/owner/hotel-management/bookings/${bookingId}`, "GET");
};

export const deleteBooking = async (bookingId) => {
  return apiRequest(`/api/owner/hotel-management/bookings/${bookingId}`, "DELETE");
};


export const updateBookingStatus = async ({bookingId, status , paymentStatus}) => {
  return apiRequest(`/api/owner/hotel-management/bookings/status/${bookingId}`, "PUT", { status , paymentStatus });
};